import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

// i18n-exempt-start: clients' quotes, verbatim; a translation would put words in their mouth
const testimonials = [
    {
        quote: "L’énergie de l’équipe Revcall, leur réactivité et leur capacité à se remettre en question en continu font une vraie différence. C’est rare de travailler avec un partenaire qui combine à ce point impact humain et excellence opérationnelle.",
        author: "Romain C.",
        role: "CEO & Founder",
        company: "Squared",
        avatar: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/cc197e5e2_1753641591558.jpeg",
        linkedin: "https://www.linkedin.com/in/romaincollignon-scale-mastermind/",
    },
    {
        quote: "Déterminant dans notre croissance. Honnêtement, je ne sais pas comment on aurait fait sans Revcall. Leur capacité à générer des rendez-vous qualifiés est exceptionnelle.",
        author: "Selim C.",
        role: "CEO & Co-founder",
        company: "MarkAI",
        avatar: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/20c5acedc_1708880177781.jpeg",
        linkedin: "https://www.linkedin.com/in/selimchehimi/",
    },
    {
        quote: "Un niveau de maîtrise rare en cold call. Qualité, cadence, compréhension produit… tout est ultra solide. C'est exactement le type de partenaire qu'on veut en phase d'hyper-croissance.",
        author: "Victor C.",
        role: "Co-founder",
        company: "HelloSearch",
        avatar: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/3cdb162ee_1727986190434.jpeg",
        linkedin: "https://www.linkedin.com/in/victor-cariou/",
    },
];
// i18n-exempt-end

export default function TestimonialsSection() {
    const { t } = useTranslation(['admin']);
    return (
        <section id="testimonials" className="relative py-32 bg-[#0a0a0a] overflow-hidden" style={{ contentVisibility: 'auto', containIntrinsicSize: '800px' }}>
            <div className="max-w-6xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-xs uppercase tracking-[0.2em] text-purple-400 mb-4 block">
                        {t('admin:landing.nav.testimonials')}
                    </span>
                    <h2 className="text-3xl md:text-5xl font-bold text-white">
                        {t('admin:landing.testimonials.heading')}
                    </h2>
                </motion.div>

                <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
                    {testimonials.map((testimonial, index) => (
                        <motion.div
                            key={testimonial.author}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            className="p-6 md:p-8 rounded-2xl bg-white/[0.02] border border-white/[0.05] hover:bg-white/[0.03] transition-colors"
                        >
                            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-6">
                                "{testimonial.quote}"
                            </p>
                            <a 
                                href={testimonial.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-4 group/author"
                            >
                                <img
                                    src={testimonial.avatar}
                                    alt={testimonial.author}
                                    width={48}
                                    height={48}
                                    loading="lazy"
                                    decoding="async"
                                    className="w-12 h-12 rounded-full object-cover ring-2 ring-white/10 group-hover/author:ring-purple-500/50 transition-all"
                                />
                                <div>
                                    <div className="font-medium text-white group-hover/author:text-purple-400 transition-colors">{testimonial.author}</div>
                                    <div className="text-sm text-white/40">{testimonial.role} · {testimonial.company}</div>
                                </div>
                            </a>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}